<div class="container">
    <!-- <div class="actions">
        <button (click)="addVehicle()" class="btn-action">
            <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
            Add Vehicle</button>
        <button (click)="bulkUpload()" class="btn-action">
            <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
            Bulk Upload</button>
    </div> -->

    <div class="container-table">
        <header class="top-header">
            <h3>Alert Records</h3>
            <p>Vehicle Details As On {{todayDate | date: "dd-MM-yyyy" }}</p>
        </header>

        <div>
            <div class="tab-head">
                
                <div class="search-bar wide-search-bar">
                    <app-generic-search [apiUrl]="'vehicle-alerts/search_suggestion'" [resultsApiUrl]="'vehicle-alerts/'"
                        [method]="'GET'" [searchParamName]="'q'" [pageSize]="10" [minChars]="2"
                                        [extraBody]="searchExtraBody"
                        (resultsFetched)="onResults($event)">
                    </app-generic-search>
                </div>
                <!-- use the global `.table-filters` styles so the selects match the app theme -->
                <div class="filters table-filters">
                    <div class="filter">
                        <label>Date Range </label>
                        <select [(ngModel)]="dateFilter" (change)="applyFilters()">
                            <option value="">All</option>
                            <option *ngFor="let opt of dateOptions" [value]="opt.value">{{ opt.label }}</option>
                        </select>
                    </div>
                    <div class="filter">
                        <label>Alert Type </label>
                        <select [(ngModel)]="alertType" (change)="applyFilters()">
                            <option value="">All</option>
                            <option *ngFor="let type of alertTypeOptions" [value]="type.value">{{ type.label }}</option>
                        </select>
                    </div>
                    <div class="filter" *ngIf="showMonitoringTypeFilter">
                        <label>Monitoring Type</label>
                        <app-monitoring-type-multiselect
                                [selectedValues]="selectedMonitoringTypes"
                                (selectionApplied)="applyMonitoringTypeFilter($event)">
                        </app-monitoring-type-multiselect>
                    </div>
                </div>
                <button (click)="exportToExcel()" class="export-button">
                    <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin"
                        style="color: white;font-size: 15px;"></fa-icon>
                    EXPORT EXCEL
                </button>
            </div>
            <div class="responsive-table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Vehicle No</th>
                            <th>Created On</th>
                            <th>Alert Type</th>
                            <th>Monitoring Type</th>
                            <th>Direction</th>
                            <th>Message</th>
                            <th>Received by</th>
                            <th>Notification Channel</th>
                            <th>Status</th>
                           
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let record of alertData let i = index ">
                            <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
                            <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                            <td>{{ record.created_at | date: 'dd-MM-yyyy hh:mm a' }}</td>
                            <td>
                                <app-alert-type-badge [alertType]="record.alert_type"></app-alert-type-badge>
                            </td>
                            <td>
                                <div class="monitoring-type-badges"
                                     *ngIf="record.alert_type === 'VEH_ALERT'; else noMonitoringTypes">
                                    <app-monitoring-type-badge
                                            *ngFor="let monitoringType of monitoringTypeCodes(record)"
                                            [monitoringType]="monitoringType">
                                    </app-monitoring-type-badge>
                                    <span *ngIf="!monitoringTypeCodes(record).length">-</span>
                                </div>
                                <ng-template #noMonitoringTypes>-</ng-template>
                            </td>
                            <td>{{ record.direction }}</td>
                            <td>{{ record.message }}</td>
                            <td>{{ record.received_by }}</td>
                            <td>{{ record.delivery_channel}}</td>
                            <td>{{ record.status}}</td>
                        </tr>
                    </tbody>
                </table>

                <div class="footer">
                    <div class="total-records">Total Records: {{ totalRecords }}</div>
                    <div class="pagination-controls">
                        <label for="recordsPerPage">Records per page </label>
                        <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()">
                            <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
                        </select>
                        <span>{{ currentPage }} / {{ totalPages }}</span>
                        <button (click)="previous()" [disabled]="!previousPage" class="change-page"
                            title="Previous page">
                            <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
                        </button>
                        <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
                            <fa-icon [icon]="['fas', 'angle-right']" class="fa-light"
                                style="background-color: none;"></fa-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>